import React from "react";
import { useHistory } from "react-router-dom";
import { withFormik } from 'formik';
import { withTranslation } from 'react-i18next';

import { getCodeableConceptSchema } from "../../../components/Validations/FormValidationSchema";
import { Success } from '../../../components/Notifications/Notifications';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';
import { createStudyTask } from "../../../api/protocolAdmin";
import { StudyTaskForm } from "../../../components/Protocols/Admin/StudyTasks";

export const CreateStudyTaskContainer = () => {
    let history = useHistory();

    const handleSubmit = () => {
        history.push(`/admin/settings/studyTasks`);
    }
    const handleCancel = () => {
        history.push(`/admin/settings/studyTasks`);
    }

    return (
        <CreateStudyTaskContainerFormik
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    );
}

const CreateStudyTaskContainerFormik = withTranslation()(withFormik({
    mapPropsToValues: (props) => ({}),

    validationSchema: getCodeableConceptSchema(),

    handleSubmit: (values, formikBag) => {
       
        createStudyTask(values.studyTask)
            .then(res => {
                formikBag.setSubmitting(false);
                Success("protocolNotifications.protocol_Created");
                formikBag.props.onSubmit(res.data);
            }).catch(error => {
                console.log(error);
                formikBag.setSubmitting(false);
                HandleApiError(error);
            });
    },

    displayName: 'StudyTaskForm',

})(StudyTaskForm));
